module.exports = __webpack_public_path__ + "img/f9b22cc.jpg";